import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Loader2, ChevronLeft, ChevronRight, ExternalLink } from "lucide-react";
import { toast } from "sonner";
import { api } from "../../lib/api";
import { ETAPAS } from "./modulesConfig";

const mxn = (v) => Number(v || 0).toLocaleString("es-MX", { style: "currency", currency: "MXN", maximumFractionDigits: 0 });
const IDX = ETAPAS.map((e) => e.value);

export default function ModulePipeline() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = () => { setLoading(true); api.get(`/mod/opportunities/items`).then((r) => setItems(r.data)).catch(() => {}).finally(() => setLoading(false)); };
  useEffect(load, []);

  const move = async (it, dir) => {
    const cur = IDX.indexOf(it.etapa);
    const next = IDX[Math.min(Math.max(cur + dir, 0), IDX.length - 1)];
    if (next === it.etapa) return;
    setItems((xs) => xs.map((x) => (x.id === it.id ? { ...x, etapa: next } : x)));
    try { await api.patch(`/mod/opportunities/items/${it.id}`, { etapa: next }); }
    catch { toast.error("Error al mover"); load(); }
  };

  if (loading) return <div className="py-8 flex justify-center text-navy/40"><Loader2 className="w-5 h-5 animate-spin" /></div>;
  if (items.length === 0) return (
    <div className="card-surface py-10 text-center text-navy/40 text-sm" data-testid="pipeline-empty">
      No hay oportunidades aún. Créalas en <Link to="/os/mod/opportunities" className="text-violet">OMNIA Opportunities</Link> y aparecerán aquí en vivo.
    </div>
  );

  return (
    <div className="overflow-x-auto pb-2" data-testid="module-pipeline">
      <div className="flex gap-3 min-w-max">
        {ETAPAS.map((et) => {
          const col = items.filter((i) => (i.etapa || "prospeccion") === et.value);
          const suma = col.reduce((s, i) => s + Number(i.valor || 0), 0);
          return (
            <div key={et.value} className="w-64 shrink-0" data-testid={`pipeline-col-${et.value}`}>
              <div className="flex items-center justify-between px-1 mb-2">
                <span className="text-xs font-medium text-navy/70">{et.label}</span>
                <span className="text-[11px] text-navy/40">{col.length} · {mxn(suma)}</span>
              </div>
              <div className="space-y-2">
                {col.map((it) => {
                  const cur = IDX.indexOf(it.etapa);
                  return (
                    <div key={it.id} className="card-surface p-3" data-testid={`pipeline-card-${it.id}`}>
                      <div className="text-sm text-navy/85 truncate">{it.nombre}</div>
                      <div className="text-[11px] text-navy/45 truncate">{it.cuenta || "—"}</div>
                      <div className="flex items-center justify-between mt-2">
                        <span className="text-sm font-medium text-navy/80">{mxn(it.valor)}</span>
                        <span className="badge badge-muted text-[10px]">{it.probabilidad || 0}%</span>
                      </div>
                      <div className="flex items-center justify-between mt-2 pt-2 border-t border-navy/5">
                        <button disabled={cur <= 0} onClick={() => move(it, -1)} className="text-navy/30 hover:text-violet disabled:opacity-20" data-testid={`pipeline-prev-${it.id}`}><ChevronLeft className="w-4 h-4" /></button>
                        <Link to="/os/mod/opportunities" className="text-navy/25 hover:text-violet" title="Abrir"><ExternalLink className="w-3.5 h-3.5" /></Link>
                        <button disabled={cur >= IDX.length - 1} onClick={() => move(it, 1)} className="text-navy/30 hover:text-violet disabled:opacity-20" data-testid={`pipeline-next-${it.id}`}><ChevronRight className="w-4 h-4" /></button>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
